import {
  ApolloClient, InMemoryCache, createHttpLink, gql,
} from '@apollo/client';
import utils from '../../utils/utils';
import packageJson from '../../../package.json';
import config from '../../temp/config';
import { endpoints } from '../../utils/constants';

export const formName = 'NewsSearch';
export const PageSize = 12;

const link = createHttpLink({
  uri: utils.isDisconnected
    ? 'http://internet.dev.local/api/internet?sc_apikey={43A6A824-9E28-4AD8-AB16-9550F0094466}'
    : `${endpoints.sitecore.graphService}?sc_apikey=${config.sitecoreApiKey}`,
});

const defaultOptions = {
  watchQuery: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'ignore',
  },
  query: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
  },
};

export const client = new ApolloClient({
  cache: new InMemoryCache(),
  link,
  defaultOptions,
});

export const SEARCH_QUERY = (sort) => gql`
    query searchItems($keyword:String, $skip:String) {    
    drsearch(fieldsEqual:
    [{
    name: "_templatename",
    value: "StaticPage"
    },
    {
    name: "newsContent",
    value: "1"
    }],
    keyword: $keyword,
    after:$skip,
    first:${PageSize},
    mediaRootItem:"/sitecore/media library/${packageJson.config.appName}/data/media/files",
    rootItem: "/sitecore/content/${packageJson.config.appName}/home",
    sort: [{name: "__publish", value: "${sort}"}]){
        results {
          totalCount
          pageInfo {
            hasNextPage
            hasPreviousPage
          }
          items{
            uri
            name
            updateddate:field(name:"__publish")
            item{
              url                
              ...on StaticPage{                
                thumbnailImage{
                  jss
                }
                heading{
                  value
                }
                description{
                  value
                }
              }
            }
          }
        }        
      }
}
`;

// Query without keyword to fetch all items for heading search
// Note: Simplified query to avoid GraphQL complexity errors - only fetches fields needed for heading filtering
export const SEARCH_ALL_QUERY = (sort) => gql`
    query searchAllItems {    
    drsearch(fieldsEqual:
    [{
    name: "_templatename",
    value: "StaticPage"
    },
    {
    name: "newsContent",
    value: "1"
    }],
    first: 20,
    rootItem: "/sitecore/content/${packageJson.config.appName}/home",
    sort: [{name: "__publish", value: "${sort}"}]){
        results {
          totalCount
          items{
            uri
            name
            item{
              url                
              ...on StaticPage{                
                heading{
                  value
                }
              }
            }
          }
        }        
      }
}
`;

export const Stages = {
  Loading: 'Loading',
  DataLoaded: 'DataLoaded',
  NoResults: 'NoResults',
  Error: 'Error',
};

export const SortOrder = {
  Ascending: 'asc',
  Descending: 'desc',
};
